import type { ReactNode } from "react";
import { EDITORIAL_CONTAINER_CLS } from "./theme";

/** The nav's page container with a narrower reading column aligned to its
 *  left edge, so index and long-read pages start where every other page
 *  starts. */
export function ReadingRail({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={EDITORIAL_CONTAINER_CLS}>
      <div className={`max-w-[68rem] ${className ?? ""}`}>{children}</div>
    </div>
  );
}
